import React from "react";
import PqrsdTrackPage from "../pqrsd/PqrsdTrackPage";

export default function LayoutPqrsdTrack() {
  return <PqrsdTrackPage />;
}
